<template>
  <layout>
    <template v-slot:header>
      <AppHead title="New Product" />
      <h2><i class="fas fa-plus text-primary mr-2"></i>New Product</h2>
      <BreadCrumbs activeItem="New Product" :crumbs="{ home: 'Dashboard', products: 'Products' }"/>
    </template>

    <template v-slot:default>
      <form class="row" @submit.prevent="store">
        <div class="col-12 col-xl-6">
          <card title="Product Info" icon="fas fa-tag" headerStyle="dark" class="mb-3">
            <div class="row">
              <div class="col-12">
                <jet-label for="name" value="Name" />
                <jet-input id="name" type="text" class="form-control" v-model="form.name" autocomplete="name" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
              </div>
              <div class="col-12 d-flex align-items-end my-3">
                <div class="form-check">
                  <input type="checkbox" id="active" class="form-check-input" v-model="form.active" />
                  <jet-label for="active" value="Active" />
                  <jet-input-error :message="form.errors.active" class="mt-2" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-sm-4">
                <jet-label for="sku" value="SKU" />
                <jet-input id="sku" type="text" class="form-control" v-model="form.sku" />
                <jet-input-error :message="form.errors.sku" class="mt-2" />
              </div>
              <div class="form-group col-sm-4">
                <jet-label for="manufacturer_reference" value="Manufacturer Reference" />
                <jet-input id="manufacturer_reference" type="text" class="form-control" v-model="form.manufacturer_reference" />
                <jet-input-error :message="form.errors.manufacturer_reference" class="mt-2" />
              </div>
              <div class="form-group col-sm-4">
                <jet-label for="upc" value="UPC" />
                <jet-input id="upc" type="text" class="form-control" v-model="form.upc" />
                <jet-input-error :message="form.errors.upc" class="mt-2" />
              </div>

              <div class="form-group col-sm-6">
                <div v-if="form.manufacturer_id == -1">
                  <jet-label for="new_manufacturer" value="New Manufacturer" />
                  <jet-input id="new_manufacturer" type="text" class="form-control" v-model="form.new_manufacturer_name" autocomplete="sku" />
                </div>

                <jet-input-error :message="form.errors.manufacturer" class="mt-2" />
              </div>
            </div>
          </card>

          <card headerStyle="dark" title="Belongs To" class="mb-3">
            <div class="row">
              <div class="col-12 col-lg-6">
                <jet-label for="manufacturer" value="Manufacturer" />
                <select v-model="form.manufacturer_id" class="form-control" id="manufacturer">
                  <option v-for="man in manufacturers" :key="man.id" :value="man.id">
                  {{ man.name }}
                  </option>
                  <option value="-1">New Manufacturer</option>
                </select>
              </div>
              <div class="col-12 col-lg-6">
                <jet-label for="categories" value="Categories" />
                <Multiselect
                  v-model="form.categories"
                  mode="tags"
                  :options="categories"
                  :searchable="true"
                  class="admin-multiselect"
                  id="category_select"
                  />
                <jet-input-error :message="form.errors.categories" class="mt-2" />
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <div class="form-check">
                  <input type="checkbox" id="wholesale_only" class="form-check-input" v-model="form.wholesale_only" />
                  <jet-label for="wholesale_only" value="Wholesale Only" />
                  <jet-input-error :message="form.errors.wholesale_only" class="mt-2" />
                </div>
              </div>
            </div>
          </card>

        </div>

        <div class="col-12 col-xl-6">
          <card headerStyle="dark" title="Descriptions" class="mb-3">
            <div class="row">
              <div class="form-group col-12">
                <jet-label for="short_description" value="Short Description" />
                <jet-input id="short_description"  class="form-control" v-model="form.short_description" />
                <jet-input-error :message="form.errors.short_description" class="mt-2" />
              </div>
              <div class="form-group col-12">
                <jet-label for="long_description" value="Long Description" />
                <textarea id="long_description"  class="form-control" v-model="form.long_description" ></textarea>
                <jet-input-error :message="form.errors.long_description" class="mt-2" />
              </div>
            </div>
          </card>

          <card headerStyle="dark" title="Shipping" class="mb-3">
            <div class="row">
              <div class="form-group col-sm-6">
                <jet-label for="ship_weight" value="Shipping - Weight" />
                <jet-input id="ship_weight" type="text" class="form-control" v-model="form.ship_weight" />
                <jet-input-error :message="form.errors.ship_weight" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label for="ship_height" value="Shipping - Height" />
                <jet-input id="ship_height"  type="text" class="form-control" v-model="form.ship_height" />
                <jet-input-error :message="form.errors.ship_height" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label for="ship_width" value="Shipping - Width" />
                <jet-input id="ship_width"  type="text" class="form-control" v-model="form.ship_width" />
                <jet-input-error :message="form.errors.ship_width" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label for="ship_length" value="Shipping - Length" />
                <jet-input id="ship_length" type="text" class="form-control" v-model="form.ship_length" />
                <jet-input-error :message="form.errors.ship_length" class="mt-2" />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-sm-6">
                <div class="form-check">
                <jet-checkbox id="ship_only_mtd"  v-model="form.ship_only_mtd" />
                <jet-label for="ship_only_mtd" value="Shipping - Only to MTD" />
                <jet-input-error :message="form.errors.ship_only_mtd" class="mt-2" />
                </div>
              </div>
              <div class="form-group col-sm-6">
                <jet-label for="ship_flat_cost" value="Shipping - Flat Shipping Cost" />
                <jet-input id="ship_flat_cost" type="text" class="form-control" v-model="form.ship_flat_cost" />
                <jet-input-error :message="form.errors.ship_flat_cost" class="mt-2" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6">
                <jet-label for="source_location_id" value="Location" />
                <select id="source_location_id" class="form-control" v-model="form.source_location_id">
                  <option></option>
                  <option v-for="address in this.warehouses" :key="address.id" :value="address.id">
                    {{ address.company_name }} {{ address.address1 }} {{ address.city }}, {{ address.state }} {{ address.postcode }}
                  </option>
                </select>
                <jet-input-error :message="form.errors.source_location_id" class="mt-2" />
              </div>
            </div>


          </card>

          <card headerStyle="dark" title="Pricing" class="mb-3">
            <div class="row">
              <div class="form-group col-sm-6">
                <jet-label for="price_msrp" value="Pricing - MSRP" />
                <AmountInput v-model="form.price_msrp" inputId="price_msrp" />
                <jet-input-error :message="form.errors.price_msrp" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label for="wholesale_price_percent" value="Pricing - Wholesale Percent" />
                <jet-input id="wholesale_price_percent"  type="text" class="form-control" v-model="form.wholesale_price_percent" />
                <jet-input-error :message="form.errors.wholesale_price_percent" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label for="wholesale_price_fixed" value="Pricing - Wholesale Fixed" />
                <AmountInput v-model="form.wholesale_price_fixed" inputId="wholesale_price_fixed" :disabled="isBundle" />
                <jet-input-error :message="form.errors.wholesale_price_fixed" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label for="case_qty" value="Case Qty" />
                <jet-input id="case_qty"  type="text" class="form-control" v-model="form.case_qty" />
                <jet-input-error :message="form.errors.case_qty" class="mt-2" />
              </div>
            </div>
          </card>
          <card headerStyle="dark" title="Video" class="mb-3">
            <div class="row">
              <div class="form-group col-sm-12">
                <jet-label for="dealer_training_video_url" value="Dealer Training Video URL" />
                <jet-input id="dealer_training_video_url"  type="text" class="form-control" v-model="form.dealer_training_video_url" />
                <jet-input-error :message="form.errors.dealer_training_video_url" class="mt-2" />
              </div>
              <div class="form-group col-sm-12">
                <jet-label for="dealer_training_video_description" value="Dealer Training Video Description" />
                <jet-input id="dealer_training_video_description"  type="text" class="form-control" v-model="form.dealer_training_video_description" />
                <jet-input-error :message="form.errors.dealer_training_video_description" class="mt-2" />
              </div>
              <div class="form-group col-sm-12">
                <jet-label for="sales_video_url" value="Sales Video URL" />
                <jet-input id="sales_video_url"  type="text" class="form-control" v-model="form.sales_video_url" />
                <jet-input-error :message="form.errors.sales_video_url" class="mt-2" />
              </div>
              <div class="form-group col-sm-12">
                <jet-label for="sales_video_description" value="Sales Video Description" />
                <jet-input id="sales_video_description"  type="text" class="form-control" v-model="form.sales_video_description" />
                <jet-input-error :message="form.errors.sales_video_description" class="mt-2" />
              </div>
            </div>
          </card>
          
        </div>

        <div class="bottom-button mt-4 mx-3">
          <jet-button class="px-5" btnStyle="success" icon="fas fa-plus" :disable="form.processing" type="submit">Create Product</jet-button>
        </div>
      </form>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'

  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import BreadCrumbs from '@/Shared/BreadCrumbs'
  import Multiselect from '@vueform/multiselect'
  import AmountInput from '@/Shared/AmountInput'

  export default {
    components: {
      JetActionMessage,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      Multiselect,
      Layout,
      BreadCrumbs,
      AmountInput
    },
    remember: 'form',
    props:  {
      manufacturers: Array,
      warehouses: Array,
      categories: Array
    },
    data() {
      return {
        form: this.$inertia.form({
          active: true,
          wholesale_only: false,
          name: null,
          sku: null,
          manufacturer_reference: null,
          upc: null,
          manufacturer_id: null,
          short_description: null,
          long_description: null,
          ship_weight: null,
          ship_height: null,
          ship_width: null,
          ship_length: null,
          ship_only_mtd: 0,
          price_msrp: 0,
          wholesale_price_percent: 0,
          wholesale_price_fixed: 0,
          source_location_id: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          postcode: null,
          new_manufacturer_name: null,
          case_qty: null,
          dealer_training_video_url: null,
          dealer_training_video_description: null,
          sales_video_url: null,
          sales_video_description: null,
        }),
      }
    },
    methods: {
      store() {
        this.form.post(this.route('products.store'))
      },
      onChange() {
        this.form.address1 = document.getElementById('address1').value
      }
    },
  }
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
